export function examplesFlicking() {
    if (!!document.querySelector('#examples-flick') === false) return;
    const flicking = new Flicking('#examples-flick', {
        bound: true,
        inputType: ['pointer'],
        preventDefaultOnDrag: true,
    });
    const flickingNav = new Flicking('#examples-flick-nav', {
        bound: true,
        inputType: [],
        autoResize: true,
    });
    window.ex = {
        f: flicking,
        nav: flickingNav,
    };
    flickingNav.on('beforeResize', () => {
        const activePanelEl = flickingNav.currentPanel.element;
        activePanelEl.style.setProperty('transition', 'unset');
        activePanelEl.classList.remove('active');
    });
    flickingNav.on('afterResize', () => {
        const activePanelEl = flickingNav.currentPanel.element;
        activePanelEl.style.removeProperty('transition');
        activePanelEl.classList.add('active');
    });
    flicking.addPlugins(
        new Flicking.Plugins.Sync({
            type: 'index',
            synchronizedFlickingOptions: [
                {
                    flicking: flicking,
                    isClickable: false,
                    isSlidable: true,
                },
                {
                    flicking: flickingNav,
                    isClickable: false,
                    activeClass: 'active',
                },
            ],
        })
    );

    const navSlides = document.querySelectorAll('#examples-flick-nav .flicking-slide');
    const lastIndex = navSlides.length - 1;
    navSlides.forEach((slide, index) => {
        const label = slide.querySelector('span:not(.arrow-left):not(.arrow-right)') || slide;
        const leftArrow = slide.querySelector('.arrow-left');
        const rightArrow = slide.querySelector('.arrow-right');

        if (label) {
            label.style.cursor = 'pointer';
            label.addEventListener('click', () => {
                flicking.moveTo(index).catch(() => {});
            });
        }

        if (leftArrow) {
            leftArrow.style.cursor = 'pointer';
            leftArrow.addEventListener('click', (e) => {
                e.stopPropagation();
                const targetIndex = index > 0 ? index - 1 : 0;
                flicking.moveTo(targetIndex).catch(() => {});
            });
        }

        if (rightArrow) {
            rightArrow.style.cursor = 'pointer';
            rightArrow.addEventListener('click', (e) => {
                e.stopPropagation();
                const targetIndex = index < lastIndex ? index + 1 : lastIndex;
                flicking.moveTo(targetIndex).catch(() => {});
            });
        }
    });
}
